(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class NavMenu extends DetailsDisclosure {
      constructor() {
        super();

        if(this.matches('.js-mega-nav')) {
          this.reset(false);
          window.addEventListener('on:breakpoint-change', this.reset.bind(this));
        }
      }

      reset(resize = true) {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;
        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }

      handleToggle(e) {
        if (!(this.matches('.js-mega-nav') && window.matchMedia(theme.mediaQueries.md).matches)) {
          super.handleToggle(e);
        }
      }
    }

    customElements.define('nav-menu', NavMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lgt-bundle-builder"] && !Shopify.designMode) return;
  try {
    
(function(){
  var root = document.querySelector('[data-lgt-bb]');
  if(!root) return;

  var MIN = parseInt(root.dataset.min, 10) || 5;
  var MAX = parseInt(root.dataset.max, 10) || 0;
  var TAG = root.dataset.tag;

  // Tiers : trier par qty asc, ignorer le palier "min"
  var tierEls = Array.from(root.querySelectorAll('[data-tier-qty]'));
  var tiers = tierEls.map(function(el){
    return {
      el: el,
      qty: parseInt(el.dataset.tierQty, 10),
      pct: parseFloat(el.dataset.tierPct) || 0
    };
  }).sort(function(a,b){ return a.qty - b.qty });

  // State : { variantId : { qty, price, title, handle } }
  var state = {};
  var lastTierUnlocked = -1;

  function totalCount(){
    var s = 0;
    for(var k in state) s += state[k].qty;
    return s;
  }
  function subtotal(){
    var s = 0;
    for(var k in state) s += state[k].qty * state[k].price;
    return s;
  }
  function currentTierPct(){
    var n = totalCount();
    var p = 0;
    tiers.forEach(function(t){ if(n >= t.qty) p = Math.max(p, t.pct) });
    return p;
  }

  function formatMoney(cents){
    var n = cents/100;
    var s = n.toFixed(2).replace('.', ',');
    return s + ' €';
  }

  function pluralize(n, word){
    return word + (n > 1 ? 's' : '');
  }

  function render(){
    var n = totalCount();
    var st = subtotal();
    var pct = currentTierPct();
    var disc = Math.round(st * pct / 100);
    var total = st - disc;

    // Card UI
    root.querySelectorAll('.lgt-bb__card').forEach(function(card){
      var id = card.dataset.productId;
      var q = state[id] ? state[id].qty : 0;
      card.querySelector('[data-qty]').textContent = q;
      card.classList.toggle('lgt-bb__card--selected', q > 0);
      var minus = card.querySelector('[data-action="minus"]');
      if(minus) minus.disabled = q === 0;
    });

    // Counts
    var countLabel = n + ' ' + pluralize(n, 'plante');
    root.querySelectorAll('[data-count], [data-count-mobile]').forEach(function(el){ el.textContent = countLabel });

    // Selection
    var sel = root.querySelector('[data-selection]');
    var selEmpty = root.querySelector('[data-selection-empty]');
    var entries = Object.values(state);
    if(entries.length === 0){
      sel.innerHTML = '';
      selEmpty.hidden = false;
    } else {
      selEmpty.hidden = true;
      sel.innerHTML = entries.map(function(it){
        return '<li><span>' + it.title + ' × ' + it.qty + '</span><span>' + formatMoney(it.price * it.qty) + '</span></li>';
      }).join('');
    }

    // Tiers visual
    var newTierUnlocked = -1;
    tiers.forEach(function(t, i){
      var active = n >= t.qty;
      t.el.classList.toggle('lgt-bb__tier--active', active);
      if(active && t.pct > 0) newTierUnlocked = Math.max(newTierUnlocked, i);
    });
    if(newTierUnlocked > lastTierUnlocked && lastTierUnlocked >= -1){
      var el = tiers[newTierUnlocked] && tiers[newTierUnlocked].el;
      if(el){
        el.classList.add('lgt-bb__tier--just-unlocked');
        setTimeout(function(){ el.classList.remove('lgt-bb__tier--just-unlocked') }, 600);
      }
    }
    lastTierUnlocked = newTierUnlocked;

    // Progress bar
    var maxTierQty = tiers.length ? tiers[tiers.length-1].qty : MIN;
    var progressPct = Math.min(100, (n / maxTierQty) * 100);
    root.querySelector('[data-progress]').style.width = progressPct + '%';

    // Totals
    root.querySelector('[data-subtotal]').textContent = formatMoney(st);
    var discRow = root.querySelector('[data-discount-row]');
    if(disc > 0){
      discRow.hidden = false;
      root.querySelector('[data-discount]').textContent = '−' + formatMoney(disc);
      root.querySelector('[data-discount-pct]').textContent = '(−' + pct + '%)';
      root.querySelector('[data-discount-note]').hidden = false;
    } else {
      discRow.hidden = true;
      root.querySelector('[data-discount-note]').hidden = true;
    }
    root.querySelector('[data-total]').textContent = formatMoney(total);
    root.querySelectorAll('[data-total-mobile]').forEach(function(el){ el.textContent = formatMoney(total) });

    // CTA states
    var atc = root.querySelector('[data-atc]');
    var atcMobile = root.querySelector('[data-atc-mobile]');
    var ctaLabel = root.querySelector('[data-cta-label]');
    var ctaLabelMobile = root.querySelector('[data-cta-label-mobile]');

    if(n < MIN){
      atc.disabled = true;
      atcMobile.disabled = true;
      var rem = MIN - n;
      ctaLabel.textContent = 'Encore ' + rem + ' ' + pluralize(rem, 'plante') + ' pour valider';
      ctaLabelMobile.textContent = '+ ' + rem;
    } else {
      atc.disabled = false;
      atcMobile.disabled = false;
      ctaLabel.textContent = 'Ajouter ma box · ' + formatMoney(total);
      ctaLabelMobile.textContent = 'Ajouter';
    }
  }

  // Click handlers
  root.addEventListener('click', function(e){
    var btn = e.target.closest('[data-action]');
    if(!btn || btn.disabled) return;
    var card = btn.closest('[data-product-id]');
    if(!card) return;
    var id = card.dataset.productId;
    var price = parseInt(card.dataset.price, 10);
    var action = btn.dataset.action;

    if(action === 'plus'){
      if(MAX > 0 && totalCount() >= MAX) return;
      if(!state[id]){
        state[id] = {
          qty: 0,
          price: price,
          title: card.dataset.title,
          handle: card.dataset.productHandle
        };
      }
      state[id].qty++;
    } else if(action === 'minus'){
      if(!state[id]) return;
      state[id].qty--;
      if(state[id].qty <= 0) delete state[id];
    }
    render();
  });

  // ATC bulk
  function addToCart(){
    var n = totalCount();
    if(n < MIN) return;
    var bundleId = 'bb-' + Date.now().toString(36) + '-' + Math.floor(Math.random()*1000);
    var items = [];
    for(var k in state){
      items.push({
        id: parseInt(k, 10),
        quantity: state[k].qty,
        properties: {
          '_bundle_id': bundleId,
          'Box composée': n + ' plantes'
        }
      });
    }

    var ctaEls = root.querySelectorAll('[data-atc], [data-atc-mobile]');
    ctaEls.forEach(function(el){ el.disabled = true; el.dataset.loading = '1' });

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {'Content-Type':'application/json','Accept':'application/json'},
      body: JSON.stringify({items: items})
    })
    .then(function(r){
      if(!r.ok) throw new Error('cart-add-failed');
      return r.json();
    })
    .then(function(){
      // Refresh drawer
      try{
        document.dispatchEvent(new CustomEvent('cart-drawer:refresh'));
        document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh'));
      }catch(e){}
      // Reset state
      state = {};
      render();
      // Open drawer if available, else redirect
      var drawer = document.querySelector('cart-drawer');
      if(drawer && typeof drawer.open === 'function'){
        setTimeout(function(){ drawer.open() }, 200);
      } else {
        window.location.href = '/cart';
      }
    })
    .catch(function(err){
      console.error('[bundle-builder] ATC error', err);
      alert('Une erreur est survenue lors de l\'ajout au panier. Réessayez ou rechargez la page.');
      ctaEls.forEach(function(el){ el.disabled = false; el.removeAttribute('data-loading') });
    });
  }

  root.querySelectorAll('[data-atc], [data-atc-mobile]').forEach(function(el){
    el.addEventListener('click', addToCart);
  });

  render();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lgt-bundle-xxl"] && !Shopify.designMode) return;
  try {
    
(function(){
  var root = document.querySelector('[data-lgt-bbxxl]');
  if(!root) return;

  var MIN = parseInt(root.dataset.min, 10) || 2;
  var MAX = parseInt(root.dataset.max, 10) || 0;
  var ENDPOINT = root.dataset.endpoint || '';
  var MARGIN = parseFloat(root.dataset.margin) || 30;
  var COUNTRY = root.dataset.country || 'FR';
  var DEBOUNCE_MS = 500;

  // State : { variantId: { qty, sku, price, title, handle } }
  var state = {};
  var debounceTimer = null;
  var currentRequestId = 0;
  var lastQuote = null;

  function totalCount(){ var s=0; for(var k in state) s += state[k].qty; return s }
  function publicSubtotalCents(){ var s=0; for(var k in state) s += state[k].qty * state[k].price; return s }

  function formatMoney(cents){
    if(cents == null || isNaN(cents)) return '—';
    return (cents/100).toFixed(2).replace('.', ',') + ' €';
  }
  function pluralize(n, word){ return word + (n > 1 ? 's' : '') }

  function setState(name){
    root.querySelectorAll('[data-state-empty],[data-state-loading],[data-state-error],[data-state-ready]').forEach(function(el){
      el.hidden = true;
    });
    var target = root.querySelector('[data-state-'+name+']');
    if(target) target.hidden = false;
  }

  function renderCards(){
    root.querySelectorAll('.lgt-bbxxl__card').forEach(function(card){
      var id = card.dataset.productId;
      var q = state[id] ? state[id].qty : 0;
      card.querySelector('[data-qty]').textContent = q;
      card.classList.toggle('lgt-bbxxl__card--selected', q > 0);
      var minus = card.querySelector('[data-action="minus"]');
      if(minus) minus.disabled = q === 0;
    });
  }

  function renderSelection(){
    var sel = root.querySelector('[data-selection]');
    var entries = Object.values(state);
    sel.innerHTML = entries.map(function(it){
      return '<li><span>'+it.title+' × '+it.qty+'</span><span>'+formatMoney(it.price*it.qty)+'</span></li>';
    }).join('');
  }

  function renderQuote(quote){
    lastQuote = quote;
    if(!quote || !quote.ok){
      var msg = (quote && quote.error_message) ? quote.error_message : 'Cette composition XXL ne peut pas être tarifée automatiquement pour le moment.';
      root.querySelector('[data-error-message]').textContent = msg;
      setState('error');
      root.querySelector('[data-atc]').disabled = true;
      root.querySelector('[data-atc-mobile]').disabled = true;
      return;
    }
    setState('ready');
    renderSelection();
    var p = quote.pricing;
    root.querySelector('[data-plants-subtotal]').textContent = formatMoney(p.plantsSubtotalDisplay);
    root.querySelector('[data-shipping]').textContent = formatMoney(p.shippingDisplay);
    root.querySelector('[data-handling]').textContent = formatMoney(p.handlingDisplay);
    root.querySelector('[data-total]').textContent = formatMoney(p.bundleTotalTarget);
    var savingsRow = root.querySelector('[data-savings-row]');
    if(p.savingsVsSeparate > 0){
      savingsRow.hidden = false;
      root.querySelector('[data-savings]').textContent = formatMoney(p.savingsVsSeparate);
    } else {
      savingsRow.hidden = true;
    }
    root.querySelector('[data-cta-label]').textContent = 'Ajouter ma box · ' + formatMoney(p.bundleTotalTarget);
    root.querySelector('[data-total-mobile]').textContent = formatMoney(p.bundleTotalTarget);
    root.querySelector('[data-cta-label-mobile]').textContent = 'Ajouter';
    root.querySelector('[data-atc]').disabled = false;
    root.querySelector('[data-atc-mobile]').disabled = false;
  }

  /* MOCK quote (Phase 1 — sera remplacé par fetch endpoint en Phase 2) */
  function mockQuote(items){
    // Simule un appel Everspring : on génère un payload cohérent à partir des items
    var qty = items.reduce(function(s, it){ return s + it.qty }, 0);
    if(qty < MIN) return null;

    // Estimation coût Everspring : prix public × 0.55 (estimation marge ~45% actuelle)
    var publicSep = items.reduce(function(s, it){ return s + it.qty * it.publicUnitPrice }, 0);
    var productTotal = Math.round(publicSep * 0.55);

    // Palier shipping (mock) selon qty
    var shipping = 18995; // palier 189.95€
    if(qty >= 4) shipping = 21995;
    if(qty >= 6) shipping = 29995;

    // Handling fixe ~10€
    var handling = 1000;

    var grandTotal = productTotal + shipping + handling;

    // Marge cible : prix_vente = cout / (1 - marge_pct/100)
    var bundleTotalTarget = Math.round(grandTotal / (1 - MARGIN/100));

    var plantSubtotal = bundleTotalTarget - shipping - handling;
    if(plantSubtotal <= 0){
      return { ok: false, error_message: 'Composition non quotable (sous-total plantes négatif).' };
    }
    if(bundleTotalTarget > publicSep){
      return { ok: false, error_message: 'Bundle plus cher que l\'achat séparé. Ajustez votre composition.' };
    }

    return {
      ok: true,
      items: items.map(function(it){ return { sku: it.sku, qty: it.qty, publicUnitPrice: it.publicUnitPrice } }),
      everspring: {
        productTotal: productTotal,
        shippingTotal: shipping,
        handlingFeeTotal: handling,
        grandTotal: grandTotal
      },
      pricing: {
        bundleTotalTarget: bundleTotalTarget,
        plantsSubtotalDisplay: plantSubtotal,
        shippingDisplay: shipping,
        handlingDisplay: handling,
        savingsVsSeparate: publicSep - bundleTotalTarget,
        marginTargetPct: MARGIN
      }
    };
  }

  function fetchQuote(){
    var n = totalCount();
    if(n < MIN){
      setState('empty');
      root.querySelector('[data-atc]').disabled = true;
      root.querySelector('[data-atc-mobile]').disabled = true;
      return;
    }

    // Build items payload
    var items = [];
    for(var k in state){
      items.push({
        variantId: k,
        sku: state[k].sku,
        qty: state[k].qty,
        publicUnitPrice: state[k].price
      });
    }

    setState('loading');
    currentRequestId++;
    var thisRequestId = currentRequestId;

    if(!ENDPOINT){
      // Phase 1 — Mock
      setTimeout(function(){
        if(thisRequestId !== currentRequestId) return; // requête obsolète
        var quote = mockQuote(items);
        renderQuote(quote);
      }, 350);
      return;
    }

    // Phase 2+ — Real endpoint (Cloudflare Worker)
    fetch(ENDPOINT, {
      method:'POST',
      headers:{'Content-Type':'application/json','Accept':'application/json'},
      body: JSON.stringify({
        items: items.map(function(it){ return { sku: it.sku, qty: it.qty, publicUnitPrice: it.publicUnitPrice } }),
        shippingCountryCode: COUNTRY
      })
    })
      .then(function(r){ return r.json().then(function(j){ return { status: r.status, body: j } }) })
      .then(function(resp){
        if(thisRequestId !== currentRequestId) return;
        renderQuote(resp.body);
      })
      .catch(function(err){
        if(thisRequestId !== currentRequestId) return;
        renderQuote({ ok: false, error_message: 'Erreur réseau. Réessayez dans un instant.' });
      });
  }

  function scheduleQuote(){
    if(debounceTimer) clearTimeout(debounceTimer);
    debounceTimer = setTimeout(fetchQuote, DEBOUNCE_MS);
  }

  function updateCount(){
    var n = totalCount();
    var label = n + ' ' + pluralize(n, 'plante');
    root.querySelectorAll('[data-count], [data-count-mobile]').forEach(function(el){ el.textContent = label });

    if(n < MIN){
      var rem = MIN - n;
      var ctaLabel = root.querySelector('[data-cta-label]');
      var ctaMobile = root.querySelector('[data-cta-label-mobile]');
      if(ctaLabel) ctaLabel.textContent = 'Encore ' + rem + ' ' + pluralize(rem, 'plante') + ' minimum';
      if(ctaMobile) ctaMobile.textContent = '+ ' + rem;
    }
  }

  /* Click +/- handlers */
  root.addEventListener('click', function(e){
    var btn = e.target.closest('[data-action]');
    if(!btn || btn.disabled) return;
    var card = btn.closest('[data-product-id]');
    if(!card) return;
    var id = card.dataset.productId;
    var price = parseInt(card.dataset.price, 10);
    var sku = card.dataset.sku;
    var action = btn.dataset.action;

    if(action === 'plus'){
      if(MAX > 0 && totalCount() >= MAX) return;
      if(!state[id]){
        state[id] = {
          qty: 0,
          price: price,
          sku: sku,
          title: card.dataset.title,
          handle: card.dataset.productHandle
        };
      }
      state[id].qty++;
    } else if(action === 'minus'){
      if(!state[id]) return;
      state[id].qty--;
      if(state[id].qty <= 0) delete state[id];
    }

    renderCards();
    updateCount();
    scheduleQuote();
  });

  /* Retry button */
  var retryBtn = root.querySelector('[data-retry]');
  if(retryBtn){
    retryBtn.addEventListener('click', function(){ fetchQuote() });
  }

  /**
   * Phase 3 (B2) — ATC via Discount Function Codex (lgt-cart-auto-pricing) :
   *  1. Fetch /cart.js pour connaître l'état actuel du panier
   *  2. Construit la signature future (sku:qty | sku:qty | ... trié)
   *  3. Calcule le discount total = publicSubtotalBundle - bundleTotalTarget
   *  4. Répartit le discount pro-rata sur les lignes du bundle
   *  5. ATC les plantes avec les 4 line item properties que la function reconnaît :
   *       _lgt_ap_enabled = "true"
   *       _lgt_ap_source  = "preview"
   *       _lgt_ap_sig     = signature
   *       _lgt_ap_discount_cents = montant_ligne (en cents)
   *  6. La function applique le discount automatiquement au checkout
   *  → Aucun redirect, aucun appel admin API
   */
  function buildSignature(lines){
    return lines.map(function(l){
      var sku = (l.sku && String(l.sku).trim()) || 'no-sku';
      var qty = Number(l.qty || 0);
      return sku + ':' + qty;
    }).sort().join('|');
  }

  function addToCart(){
    if(!lastQuote || !lastQuote.ok) return;
    var n = totalCount();
    if(n < MIN) return;

    var bundleTotal = lastQuote.pricing.bundleTotalTarget;
    var publicSubtotalBundle = 0;
    for(var k in state){ publicSubtotalBundle += state[k].qty * state[k].price; }
    var totalDiscountCents = publicSubtotalBundle - bundleTotal;
    if(totalDiscountCents <= 0){
      alert('Aucune économie applicable sur cette composition.');
      return;
    }

    var ctaEls = root.querySelectorAll('[data-atc], [data-atc-mobile]');
    ctaEls.forEach(function(el){ el.disabled = true });
    var ctaLabel = root.querySelector('[data-cta-label]');
    var origLabel = ctaLabel ? ctaLabel.textContent : '';
    if(ctaLabel) ctaLabel.textContent = 'Ajout au panier…';

    // Step 1 — Fetch panier actuel
    fetch('/cart.js', {headers:{'Accept':'application/json'}})
      .then(function(r){ return r.json(); })
      .then(function(currentCart){
        var currentLines = (currentCart.items || []).map(function(it){
          return { sku: it.sku || 'no-sku', qty: it.quantity || 0 };
        });

        // Step 2 — Construire la signature future
        var bundleLines = [];
        for(var k in state){
          bundleLines.push({ sku: state[k].sku || 'no-sku', qty: state[k].qty });
        }
        var allLines = currentLines.concat(bundleLines);
        var signature = buildSignature(allLines);

        // Step 3 — Répartition pro-rata du discount par ligne bundle
        var bundleId = 'bbxxl-' + Date.now().toString(36) + '-' + Math.floor(Math.random()*1000);
        var addItems = [];
        var distributed = 0;
        var keys = Object.keys(state);

        for(var i = 0; i < keys.length; i++){
          var key = keys[i];
          var entry = state[key];
          var linePub = entry.qty * entry.price;
          var lineDiscount;
          if(i === keys.length - 1){
            // Dernière ligne : prend le reste pour éviter l'erreur d'arrondi
            lineDiscount = totalDiscountCents - distributed;
          } else {
            lineDiscount = Math.floor(linePub / publicSubtotalBundle * totalDiscountCents);
            distributed += lineDiscount;
          }
          addItems.push({
            id: parseInt(key, 10),
            quantity: entry.qty,
            properties: {
              '_lgt_ap_enabled': 'true',
              '_lgt_ap_source': 'preview',
              '_lgt_ap_sig': signature,
              '_lgt_ap_discount_cents': String(lineDiscount),
              '_bundle_id': bundleId,
              '_bundle_type': 'xxl',
              'Box XXL composée': n + ' plantes'
            }
          });
        }

        // Step 4 — ATC standard
        return fetch('/cart/add.js', {
          method:'POST',
          headers:{'Content-Type':'application/json','Accept':'application/json'},
          body: JSON.stringify({ items: addItems })
        });
      })
      .then(function(r){ if(!r.ok) throw new Error('cart_add_failed'); return r.json(); })
      .then(function(){
        // Step 5 — Reset + drawer / cart
        try{ document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh', {bubbles:true})); }catch(e){}
        state = {};
        renderCards();
        updateCount();
        setState('empty');
        if(ctaLabel) ctaLabel.textContent = origLabel;
        var drawer = document.querySelector('cart-drawer');
        if(drawer && typeof drawer.open === 'function'){
          setTimeout(function(){ try{ drawer.open() }catch(e){} }, 200);
        } else {
          window.location.href = '/cart';
        }
      })
      .catch(function(err){
        console.error('[bundle-xxl] ATC error', err);
        alert('Erreur lors de l\'ajout au panier : ' + (err.message || 'inconnue'));
        ctaEls.forEach(function(el){ el.disabled = false });
        if(ctaLabel) ctaLabel.textContent = origLabel;
      });
  }

  root.querySelectorAll('[data-atc], [data-atc-mobile]').forEach(function(el){
    el.addEventListener('click', addToCart);
  });

  /* Initial render */
  setState('empty');
  updateCount();
})();

  } catch(e) { console.error(e); }
})();
})();
